<template>
  <div class="col-12 col-lg-6">
    <div class="card shadow-sm">
      <div class="card-header bg-primary py-3 my-0">
        <h2 class="text-lg py-0 my-0 text-center text-white">รายการเพิ่มเลข 30 อันดับล่าสุด</h2>
      </div>
      <div class="card-body py-3">
        <div class="d-flex border-bottom">
          <div class="flex-width text-center text-lg">ลำดับ</div>
          <div class="flex-width text-center text-lg">ชื่อ</div>
          <div class="flex-width text-center text-lg">เลข</div>
          <div class="flex-width text-center text-lg">เวลาส่ง</div>
        </div>
        <div class="w-100 h-200">
          <div v-for="(item, index) in items" :key="item.index">
            <div class="d-flex border-bottom align-items-center p-1">
              <div class="flex-width text-center text-sm">
                {{ index + 1 }}
              </div>
              <div class="flex-width text-center text-sm">
                {{ item.masked_name }}
              </div>
              <div class="flex-width text-center text-sm text-monospace">
                {{ showShootDigit(item.digit) }}
              </div>
              <div class="flex-width text-center text-sm">
                {{ item.created_at }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShootList',
  props: {
    gameId: { type: Number, default: '' },
    gameMasterId: { type: Number, default: '' },
  },
  data() {
    return {
      items: [],
      result: 0,
      summary: 0,
      winFirst: '',
      winSecond: '',
      winFirstDigit: '',
      winSecondDigit: '',
    };
  },
  computed: {},
  watch: {},
  created() {
    Echo.join(`gambleshoot.${this.gameId}`).listen('shooted', (response) => {       
      this.items = response.items.map((i, index) => {
        if (index == 0) {
          this.winFirst = i.name;
          this.winFirstDigit = i.digit;
        }
        if (index == 15) {
          this.winSecond = i.name;
          this.winSecondDigit = i.digit;
        }
        return {
          name: i.name,
          masked_name: i.masked_name,
          digit: i.digit,
          created_at: new Date(i.created_at).toLocaleString(),
        };
      });
      this.summary = response.summary;
      this.result = response.gamble.result;
      this.$emit('child-statusUpdate', [
        this.summary,
        this.result,
        this.winFirst,
        this.winSecond,
        this.winFirstDigit,
        this.winSecondDigit,
      ]);
    });
  },
  mounted() {
    window.axios.get(`/api/gamble/shoot/${this.gameId}`).then((res) => {
      const { items } = res.data;
      if (items.length > 0) {
        this.items = items.map((i, index) => {
          if (index == 0) {
            this.winFirst = i.name;
            this.winFirstDigit = i.digit;
          }

          if (index == 15) {
            this.winSecond = i.name;
            this.winSecondDigit = i.digit;
          }

          return {
            name: i.name,
            masked_name: i.masked_name,
            digit: i.digit,
            created_at: new Date(i.created_at).toLocaleString(),
          };
        });
      } else {
        this.winFirst = 'ไม่ระบุ';
        this.winFirstDigit = res.data.gamble.gamble_shooting_plus_number;
        this.winSecond = 'ไม่ระบุ';
        this.winSecondDigit = res.data.gamble.gamble_shooting_minus_number;
      }

      this.summary = res.data.summary;
      this.result = res.data.gamble.result;
      this.$emit('child-statusUpdate', [
        this.summary,
        this.result,
        this.winFirst,
        this.winSecond,
        this.winFirstDigit,
        this.winSecondDigit,
      ]);
    });
  },
  methods: {
    showShootDigit(val) {
      switch (val.toString().length) {
        case 1:
          return `0000${val}`;
        case 2:
          return `000${val}`;
        case 3:
          return `00${val}`;
        case 4:
          return `0${val}`;
        default:
          return val;
      }
    },
  },
};
</script>
